import { render, staticRenderFns } from "./DettaglioAzienda.vue?vue&type=template&id=f2ee2ca0&"
import script from "./DettaglioAzienda.vue?vue&type=script&lang=js&"
export * from "./DettaglioAzienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports